module.exports = __webpack_public_path__ + "overview-page-4a4a10685be94c3e29e4b405a9d2131a.png";